import PropTypes from 'prop-types';

import { Container } from './styles';

const Title = ({ label }) => {
  return <Container>{label}</Container>;
};

Title.propTypes = {
  label: PropTypes.string.isRequired,
};

export default Title;
